import React from 'react';

import Hover from 'bloko/blocks/drop/Hover';
import Tip from './index';

const HoverTip = ({ children, ...props }) => (
    <Hover DropElement={Tip} {...props}>
        {children}
    </Hover>
);

export default HoverTip;

export { Tip };
